import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";

import protectedAxios from "../common/axios";
import { API_URL } from "../common/constants";
import { useInterval } from "../common/useInterval";
import {
  activityBackendSync,
  pushData,
} from "../common/activity/activityBackendSync";

const HEARTBEAT_INTERVAL = 1 * 60 * 1000;

const UserPresence = ({ children }) => {
  const gamePlayerId = useSelector((state) => state.user?.profile?._id);
  const createdAtTimestamp = useSelector(
    (state) => state.user?.profile?.createdAt
  );
  const firstName = useSelector((state) => state.user?.profile?.firstName);
  const userName = useSelector((state) => state.user?.profile?.userName);
  const lastName = useSelector((state) => state.user?.profile?.lastName);
  const email = useSelector((state) => state.user?.profile?.email);
  const accessToken = useSelector((state) => state.user?.accessToken);

  const heartbeat = useCallback(() => {
    // execute user presence API only if user is logged in
    if (!gamePlayerId || !accessToken) return;

    var userId = gamePlayerId || null;
    if (userId) {
      try {
        if (window.clarity) window?.clarity("identify", userId);
      } catch (error) {
        console.error(error);
      }
    }

    try {
      if (window.clarity) {
        window?.clarity("set", "First Name", firstName);
        window?.clarity("set", "Last Name", lastName);
        window?.clarity("set", "Username", userName);
        window?.clarity("set", "Signed up At", createdAtTimestamp);
      }
    } catch (error) {
      console.error(error);
    }

    window?.dataLayer?.push({
      user_id: userId,
    });

    Sentry?.setUser({ id: gamePlayerId, username: userName, email: email });

    protectedAxios
      .post(`${API_URL}/v1/presence`, {
        entity_id: gamePlayerId,
      })
      .catch((error) => {
        console.log("Sorry, we are unable to sync with backend");
      });

    // Push recent activities of the users to
    // nbyula server
    pushData();
  }, [gamePlayerId, accessToken, pushData]);

  useEffect(() => {
    heartbeat();
    activityBackendSync();
  }, [heartbeat, email, firstName, lastName]);

  useInterval(() => {
    heartbeat();
  }, HEARTBEAT_INTERVAL);

  return <>{children}</>;
};

export default UserPresence;
